module.exports = __webpack_public_path__ + "static/media/sound.9fd5812c.mp3";